var map = {
	"./acacia.webp": 6242,
	"./almond.webp": 6265,
	"./apple.webp": 7712,
	"./apricot.webp": 8475,
	"./asparagus.webp": 7552,
	"./backcurrant leaf.webp": 2766,
	"./bakedstewed fruits.webp": 3667,
	"./banana.webp": 8388,
	"./biscuit.webp": 1789,
	"./black cherry.webp": 2651,
	"./black plum.webp": 4334,
	"./blackberry.webp": 1699,
	"./blackcurrant.webp": 1597,
	"./blackwhite pepper.webp": 4892,
	"./blank.webp": 1566,
	"./blossom.webp": 3124,
	"./blueberry.webp": 6972,
	"./bramble.webp": 4051,
	"./bread dough.webp": 9499,
	"./bread.webp": 7651,
	"./brioche.webp": 5723,
	"./butter.webp": 2296,
	"./candy.webp": 3891,
	"./caramel.webp": 4662,
	"./cedar.webp": 1467,
	"./charmomile.webp": 5497,
	"./charred wood.webp": 1172,
	"./cheese.webp": 65,
	"./chocolate.webp": 2590,
	"./cinnamon.webp": 6352,
	"./cloves.webp": 8566,
	"./coconut.webp": 594,
	"./coffee.webp": 620,
	"./cooked blackberry.webp": 2453,
	"./cooked fruit.webp": 2926,
	"./cooked red plum.webp": 1196,
	"./cranberry.webp": 8210,
	"./cream.webp": 2447,
	"./dill.webp": 4601,
	"./dried apple.webp": 942,
	"./dried apricot.webp": 7631,
	"./dried banana.webp": 9016,
	"./dried blackberry.webp": 6762,
	"./dried cranberry.webp": 9133,
	"./dried fruit.webp": 6849,
	"./dried herbs.webp": 198,
	"./earth.webp": 5755,
	"./elderflower.webp": 6858,
	"./eucalyptus.webp": 5062,
	"./farmyard.webp": 7084,
	"./fennel.webp": 2896,
	"./fig.webp": 129,
	"./flint.webp": 154,
	"./forest floor.webp": 2909,
	"./game.webp": 297,
	"./geranium.webp": 5618,
	"./ginger.webp": 9844,
	"./gooseberry.webp": 8266,
	"./grape.webp": 2222,
	"./grapefruit.webp": 2485,
	"./grass.webp": 7400,
	"./green bell pepper (capsicum).webp": 2635,
	"./hay.webp": 5344,
	"./hazelnut.webp": 6861,
	"./honey.webp": 107,
	"./honeysuckle.webp": 3634,
	"./jamminess.webp": 8277,
	"./kerosene.webp": 7797,
	"./kirsch.webp": 7949,
	"./lavender.webp": 776,
	"./leather.webp": 5129,
	"./lemon peel.webp": 4666,
	"./lemon.webp": 8886,
	"./lime juice.webp": 495,
	"./lime zest.webp": 9650,
	"./lime.webp": 4787,
	"./liquorice.webp": 6060,
	"./lychee.webp": 7378,
	"./mango.webp": 6212,
	"./marmalade.webp": 2334,
	"./meat.webp": 1477,
	"./meaty.webp": 9827,
	"./medicinal.webp": 7943,
	"./melon.webp": 6723,
	"./mint.webp": 5307,
	"./mushroom.webp": 3801,
	"./nectarine.webp": 9300,
	"./nutmeg.webp": 7224,
	"./nutty.webp": 6363,
	"./orange marmalade.webp": 93,
	"./orange peel.webp": 134,
	"./orange.webp": 933,
	"./passion fruit.webp": 1690,
	"./pastry.webp": 6413,
	"./peach.webp": 2226,
	"./pear drop.webp": 8356,
	"./pear.webp": 1447,
	"./petrol (gasoline).webp": 6031,
	"./petrol.webp": 9627,
	"./pineapple.webp": 6937,
	"./preserved fruits.webp": 997,
	"./prune.webp": 5384,
	"./quince.webp": 750,
	"./raisin.webp": 8800,
	"./raspberry.webp": 3506,
	"./red cherry.webp": 5183,
	"./red plum.webp": 9253,
	"./redcurrant.webp": 9913,
	"./ripe fruit.webp": 511,
	"./rose.webp": 3903,
	"./savoury.webp": 3143,
	"./smoke.webp": 2641,
	"./strawberry.webp": 636,
	"./sultana.webp": 2794,
	"./tar.webp": 2748,
	"./toast.webp": 3640,
	"./toasted bread.webp": 8146,
	"./tobacco.webp": 609,
	"./tomato leaf.webp": 8393,
	"./unripe fruit.webp": 1158,
	"./vanilla.webp": 4900,
	"./vegetal.webp": 4029,
	"./violet.webp": 1423,
	"./walnut.webp": 8362,
	"./wet leaves.webp": 8267,
	"./wet stones.webp": 3770,
	"./wet wool.webp": 5404,
	"./yogurt.webp": 9614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1027;